import '/opt/build/repo/node_modules/@storybook/addon-designs/register.js';